<template>
	<!-- 评论模块 图片显示用户头像获取本地-->
	<div class="discuss_warp">
		<div class="dis_input">
			<div class="user_img">
				<img src="../../imges/i-header-comment.png" alt="">
			</div>
			<!-- 输入框 -->
			<div class="user_input">
				<el-input placeholder="写下您的评论" v-model="comment.content" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="commentsPost">提交</el-button>
				</el-input>
			</div>
		</div>
		<!-- 评论事件 -->
		<div class="com_content">
			<div class="com_list" v-for="(item,index) in commentList" :key="index">
				<!-- 首行用户信息 -->
				<div class="con_user">
					<div class="user_img">
						<img :src="'https://admin.shipoe360.com/public/'+item.icon" alt="">
					</div>
					<div class="user_name">{{item.nickname}}<span id="1" style="font-size: 12px;margin-left: 20px;">
							{{dateFormat(item.create_time*1000)}}
						</span></div>
					<!-- <div class="user_creditime">{{item.create_time}}</div> -->
					<!-- 点赞 -->
					<!-- 点赞后添加thumbs_ups -->
					<!-- <div class="thumbs_up">
                    <span class="glyphicon glyphicon-thumbs-up"></span>
                    <span>{{item.link}}</span>
                </div> -->
				</div>
				<!-- 评论内容 -->
				<div class="con_text">
					{{item.content}}
				</div>
				<!-- 底部回复框 -->
				<div class="reply_warp">
					<!-- <div class="reply_btn">
                    <div class="hf_btn" @click="HF_frist(index)">回复</div>
                    <div class="hf_btn" @click="HF_GB"  v-show="input_f == index">关闭</div>
                    <div class="ckhf_btn" @click="showHFTo">
                        <span>查看回复</span>
                        <span class="glyphicon glyphicon-menu-right" v-show="!showHF"></span>
                        <span class="glyphicon glyphicon-menu-down" v-show="showHF"></span>
                    </div>
                </div> -->
					<!-- 回复框 -->
					<div class="hf_warp" v-show="input_f == index">
						<el-input placeholder="请输入内容" v-model="comment.content" class="input-with-select">
							<el-button slot="append" icon="el-icon-search" @click="replyF(item.id)">发布</el-button>
						</el-input>
					</div>
					<!-- 子评论框 -->
					<div class="child_warp" v-show="showHF">
						<div class="child_list" v-for="(cItem,index1) in item.childList" :key="index1">
							<div class="con_user">
								<div class="user_img">
									<img src="../../imges/gg_01.jpg" alt="">
								</div>
								<div class="user_name" style="font-size:14px;">{{cItem.username}}</div>
								<div class="user_name2" style="font-size:14px;" v-show="cItem.username2">
									<span>@&nbsp;&nbsp;</span>
									<span>{{cItem.username2}}</span>
								</div>
								<div class="user_creditime">{{getLocalTime(item.posttime)}}</div>
								<!-- 点赞 -->
								<!-- <div class="thumbs_up">
                                <span class="glyphicon glyphicon-thumbs-up"></span>
                                <span>{{cItem.link}}</span>
                            </div> -->
							</div>
							<!-- 评论内容 -->
							<div class="con_text">
								{{cItem.content}}
							</div>
							<div class="child_hf">
								<span @click="childHF(index1)">回复</span>
								<span @click="childGBHF" v-show="input_child == index1">关闭</span>
							</div>

							<!-- 回复框 -->
							<div class="hf_warp" v-show="input_child == index1">
								<el-input placeholder="请输入内容" v-model="comment.content" class="input-with-select">
									<el-button slot="append" icon="el-icon-search" @click="replyChild(cItem.id)">发布
									</el-button>
								</el-input>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		props: {
			model: String,
			cid: Number,
			models: String,
			inputName: ''
		},
		data() {
			return {
				ip: '',
				cnmuid: '',
				comment: {
					touid: '',
					model: 'xp',
					content: '', //评论内容
					userId: '', //用户id
					cid: '', //文章ID
					pid: 0, //评论等级，一级评论标识为0，二级评论为上级评论id
				},
				ids: '',
				jszid: '',
				commentList: [],
				// 回复框逻辑控制
				input_f: '-99',
				input_child: '-99',
				showHF: false,
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			getUserIP(onNewIP) {
				let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window
					.webkitRTCPeerConnection;
				let pc = new MyPeerConnection({
					iceServers: []
				});
				let noop = () => {};
				let localIPs = {};
				let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
				let iterateIP = (ip) => {
					if (!localIPs[ip]) onNewIP(ip);
					localIPs[ip] = true;
				};
				pc.createDataChannel('');
				pc.createOffer().then((sdp) => {
					sdp.sdp.split('\n').forEach(function(line) {
						if (line.indexOf('candidate') < 0) return;
						line.match(ipRegex).forEach(iterateIP);
					});
					pc.setLocalDescription(sdp, noop, noop);
				}).catch((reason) => {});
				pc.onicecandidate = (ice) => {
					if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex))
						return;
					ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
				};
			},
			// 显示子评论
			showHFTo() {
				if (this.showHF) {
					this.showHF = false
				} else {
					this.showHF = true
				}
			},
			//显示父级回复框，后期修改index控制不同父级
			HF_frist(val) {
				this.input_f = val
			},
			childHF(val) {
				this.input_child = val
			},
			HF_GB() {
				this.input_f = '-99'
			},
			childGBHF() {
				this.input_child = '-99'
			},
			// 一级评论回复点赞
			replyF(fid) {
				this.comment.topComment = fid //上级评论id
				console.log(this.comment)
			},
			// 子评论回复
			replyChild(fid) {
				this.comment.topComment = fid //上级评论id
				console.log(this.comment)
			},
			// 直接发布评论
			commentsPost() {
				console.log(this.comment.content)
				//          this.comment.pid = 0
				//          this.addComment()
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo == null) {
					alert('请登录')
					this.$router.push({
						path: '/login'
					})
				} else {
					this.cnmuid = String(loginInfo.id)
					console.log(this.cnmuid)
					this.$axios({
						url: 'https://admin.shipoe360.com/api/picture/personal_release',
						method: 'post',
						data: {
							sysid: '53',
							uid: this.cnmuid,
							obj_id: '1',
							// obj_id:this.jszid,
							url_link: this.$route.path + '?id=' + this.$route.query.id + '&title=' + this.$route
								.query.title,
							send_id: this.cnmuid,
							content: this.comment.content,
							aid: this.$route.query.id,
							pc_link: this.$route.path + '?id=' + this.$route.query.id + '&title=' + this.$route
								.query.title
						}
					}).then(res => {
						console.log(res)
						this.comment.content = ''

						this.cxlya()
						if (res.data.data == "发布成功") {
							alert("发布成功")
						}
					})
				}


			},
			// 1.about ：关于我们
			// 2.industry: 行业资讯
			// 3.daka :大咖云集
			// 4.meet：展会会议
			// 5.xp:新品
			// 6.tuku:船图
			// 7.hr:职位
			// 8.video:今日视频

			// cxly(){
			// 	this.$axios({
			// 		url:'https://admin.shipoe360.com/api/picture/commentindex',
			// 		method:'post',
			// 		data:{
			// 			model:this.models
			// 		}
			// 	}).then(res=>{
			// 		console.log(res)
			// 	})
			// },

			//      getComment(model,cid){
			//          let myURL = 'https://admin.shipoe360.com/api/comment/comment?model='+ model + '&cid='+ cid
			//          this.$axios({
			//              headers: {
			//              'Authorization': this.$storage.getItem("token")
			//              },
			//              url:myURL,
			//              method: "get",
			//          }).then((result) => {
			//              console.log('评论',result)
			//              this.commentList = result.data.data
			//          }).catch((err)=>{
			// 	console.log(err)
			// })
			//      },
			addComment() {
				this.$axios({
					url: 'https://admin.shipoe360.com/api/comment/addComment',
					method: "post",
					data: this.comment
				}).then((result) => {
					console.log('评论tianjia1', result)
				}).catch((err) => {
					console.log(err)
				})
			},
			//时间
			formatTime(timestamp, separator = '-', timeS = ':', flag = true) {
				let str = '';
				let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				let Y = date.getFullYear() + separator;
				let M = this.autoChange(date.getMonth() + 1) + separator; //计算机的月份是从0开始滴，需要+1
				let D = this.autoChange(date.getDate());
				str = Y + M + D;
				if (flag) {
					let h = this.autoChange(date.getHours()) + timeS;
					let m = this.autoChange(date.getMinutes()) + timeS;
					let s = this.autoChange(date.getSeconds());
					let timeStr = h + m + s;
					str += " ";
					str += timeStr;
				}
				return str;
			},
			dateFormat(time) {
				const t = new Date(time)
				// 日期格式
				const format = 'Y-m-d h:i:s'
				let year = t.getFullYear()
				// 由于 getMonth 返回值会比正常月份小 1
				let month = t.getMonth() + 1
				let day = t.getDate()
				let hours = t.getHours()
				let minutes = t.getMinutes()
				let seconds = t.getSeconds()
				month = month > 9 ? month : `0${month}`
				day = day > 9 ? day : `0${day}`
				hours = hours > 9 ? hours : `0${hours}`
				minutes = minutes > 9 ? minutes : `0${minutes}`
				seconds = seconds > 9 ? seconds : `0${seconds}`
				const hash = {
					'Y': year,
					'm': month,
					'd': day,
			 	'h': hours,
			  'i': minutes,
					's': seconds
				}
				return format.replace(/\w/g, o => {
					return hash[o]
				})
			},

			autoChange(num) {
				if (num < 10) {
					return "0" + num;
				} else {
					return num;
				}
			},
			async cxlya() {
				console.log(this.inputName)
				let res = await http.get('api/picture/inform_detail', {
					id: this.$route.query.id
				})
				console.log(res)
				this.commentList = res.data.data.list.replace
			},

		},
		watch: {
			inputName(newVal) {
				console.log(newVal)
				this.cxlya()
				// this.ids = newVal;
			}
			// async cxlya() {
			// 	console.log(this.$route.query.id)

			// },

		},
		mounted() {
			this.cxlya()
			this.getUserIP((ip) => {
				this.ip = ip;
			});
			// console.log(this.dateFormat(1650965089*1000))
			// console.log(this.inputName)
			// this.comment.cid = this.$route.query.id
			// this.comment.userId = this.$storage.getItem("user").id

			// this.getComment('xp',37)
		}
	}
</script>

<style rel="stylesheet/scss" scoped>
	.child_warp {
		margin-top: 8px;
	}

	.child_hf {
		color: #1872fa;
		cursor: pointer;
	}

	.user_name2,
	.user_name {
		float: left;
		font-size: 16px;
		line-height: 40px;
		margin-left: 12px;
		color: #226bf3;
		cursor: pointer;
		font-weight: 600;
	}

	.user_creditime {
		line-height: 42px;
		float: left;
		margin-left: 20px;
		font-size: 0.9rem;
		color: #7e7b7b;
	}

	.thumbs_up {
		float: right;
		line-height: 40px;
		cursor: pointer;
	}

	.thumbs_ups {
		color: red;
	}

	.reply_btn::after,
	.con_user::after,
	.com_list::after {
		content: '';
		display: block;
		clear: both;
	}

	.com_list {
		width: 90%;
		margin-left: 5%;
		font-size: 14px;
	}

	.con_text {
		margin-left: 52px;
	}

	.hf_warp {
		margin-top: 6px;
	}

	.hf_btn {
		float: left;
		margin-right: 12px;
	}

	.ckhf_btn {
		float: left;
	}

	.reply_btn {
		color: royalblue;
		cursor: pointer;
	}

	.reply_warp {
		margin-left: 52px;
		margin-top: 10px;
	}

	.user_img {
		float: left;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		overflow: hidden;

	}

	.user_input {
		width: calc(100% - 80px) !important;
		margin-top: 6px;
		float: right;
	}

	.user_img {
		float: left;
		width: 50px;
		height: 50px;
		border-radius: 50%;
		overflow: hidden;
	}

	.user_img>img {
		width: 100%;
		height: 100%;
	}

	.dis_input::after {
		content: '';
		display: block;
		clear: both;
	}

	.discuss_warp /deep/ .el-button.el-button--default {
		letter-spacing: 12px;
	}

	.discuss_warp /deep/ .el-input__inner {
		border: 1px solid #424242;
	}

	.el-icon-search:before {
		content: '';
	}

	.discuss_warp /deep/ .el-input-group__append,
	.el-input-group__prepend {
		background-color: #E82904;
		border: 1px solid #424242;
		color: #fff;
		font-size: 1.1rem;
		padding: 0 50px;
	}

	.user_img>img {
		width: 100%;
		height: 100%;
	}

	.con_user {
		margin-top: 10px;
	}

	.com_content {
		width: 100%;
		max-height: 240px;
		overflow: scroll;
		min-height: 40px;
		/* margin-top: 40px;
		margin-left: 20px; */
	}
</style>
